import React from 'react';
import { bool } from 'prop-types';

export default function ProductCardExtra({
    hasFreeDelivery,
    hasMultiPayment,
    topSale,
}) {
    return (
        <ul className="product-card-extra list">
            {hasFreeDelivery ? (
                <li className="list__item">
                    <i className="list__content list__icon list__icon--listing icon icon__truck" />
                    <span className="list__content-text">
                        Livraison gratuite
                    </span>
                </li>
            ) : (
                <li className="list__item list__item--mobile">&nbsp;</li>
            )}

            {hasMultiPayment ? (
                <li className="list__item">
                    <i className="list__content list__icon list__icon--listing icon icon__3x" />
                    <span className="list__content-text">
                        Paiement 3X sans frais
                    </span>
                </li>
            ) : null}

            {!hasMultiPayment && topSale ? (
                <li className="list__item list__item--mobile" />
            ) : null}
        </ul>
    );
}

ProductCardExtra.propTypes = {
    hasFreeDelivery: bool,
    hasMultiPayment: bool,
    topSale: bool,
};

ProductCardExtra.defaultProps = {
    hasFreeDelivery: false,
    hasMultiPayment: false,
    topSale: false,
};
